var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56226 6.39038L10.0427 2.82253C10.1754 2.6903 10.3464 2.625 10.5171 2.625C10.7105 2.625 10.8748 2.6935 10.9844 2.8152L14.472 6.39038C14.7242 6.65691 14.7189 7.07588 14.4635 7.32067C14.325 7.44448 14.1668 7.50748 13.9996 7.50748C13.8287 7.50748 13.657 7.44147 13.5243 7.30905L11.1559 4.89909V13.0113C11.1559 13.3805 10.8688 13.6675 10.4996 13.6675C10.1304 13.6675 9.84336 13.3805 9.84336 13.0113V4.89909L7.4743 7.30968C7.2188 7.5645 6.80167 7.56373 6.58096 7.33075L6.57678 7.32657C6.31186 7.06165 6.31156 6.65529 6.56226 6.39038Z",
    fill: "#2B3D50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19336 12.5213C3.19336 12.1521 3.48042 11.865 3.84961 11.865C4.2188 11.865 4.50586 12.1521 4.50586 12.5213V16.625H16.4934V12.5213C16.4934 12.1521 16.7804 11.865 17.1496 11.865C17.5188 11.865 17.8059 12.1521 17.8059 12.5213V17.2813C17.8059 17.6504 17.5188 17.9375 17.1496 17.9375H3.84961C3.48042 17.9375 3.19336 17.6504 3.19336 17.2813V12.5213Z",
    fill: "#2B3D50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.75ac0e86a9b59d941e3cf81a68450dff.svg";
export { ForwardRef as ReactComponent };